import React from 'react';

interface PerformanceItemProps {
  label: string;
  value: string;
}

export const PerformanceItem: React.FC<PerformanceItemProps> = ({
  label,
  value,
}) => {
  return (
    <div className="flex justify-between items-center">
      <span className="text-sm">{label}</span>
      <span className="text-sm font-medium">{value}</span>
    </div>
  );
};
